import { render, staticRenderFns } from "./ListagemFornecedorHeader.vue?vue&type=template&id=320d775e"
import script from "./ListagemFornecedorHeader.vue?vue&type=script&lang=js"
export * from "./ListagemFornecedorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports